<template>
  <Layout :removePadding="true">
    <v-progress-circular
      v-if="!userData"
      indeterminate
      color="primary"
      class="absolute-center"
    ></v-progress-circular>
    <div v-else>
      <BalanceData
        class="sticky-balance"
        :balance="userData.balance"
        :tokens="userData.tokens"
        :routeNames="routeNames"
      ></BalanceData>
      <v-main style="margin-top: 12rem">
        <v-container fluid class="px-8 pt-15">
          <BigButton
            :label="$t('main.recharge')"
            icon="add_circle"
            @click.native="$router.push({ name: routeNames.RECHARGE })"
          ></BigButton>
          <BigButton
            :label="$t('main.transactions')"
            icon="wysiwyg"
            @click.native="
              $router.push({
                name: routeNames.TRANSACTIONS,
                params: { showTransactionsWarningModal: true },
              })
            "
          ></BigButton>
          <BigButton
            :label="$t('main.balance_return')"
            icon="attach_money"
            :disabled="!isRefundAvailable || isRefundPending"
            :msg_disabled="
              isRefundPending
                ? null
                : $t('main.balance_return_disabled_msg', {
                    date: refundAvailableDate,
                  })
            "
            @click.native="
              !isRefundAvailable || isRefundPending
                ? null
                : $router.push({ name: routeNames.BALANCE_REFUND })
            "
          ></BigButton>
        </v-container>
      </v-main>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { RequestService } from "../services/request.service";
import errorManager from "../services/error.manager";
import { mapState } from "vuex";
const requestService = new RequestService();

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      userData: null,
      refund: null,
    };
  },
  components: {
    Layout,
    BalanceData: require("@/components/BalanceData").default,
    BigButton: require("@/components/form-elements/BigButton").default,
  },
  computed: {
    ...mapState({
      refundAvailable: (state) =>
        state.customization.customization.economics.refund_available,
    }),
    refundAvailableDate() {
      const date = moment(this.refundAvailable).tz("UTC");
      return date.format("DD/MM/YYYY hh:mm");
    },
    isRefundPending() {
      return this.refund && this.refund.status === "PENDING" ? true : false;
    },
    isRefundAvailable() {
      return window.moment(this.refundAvailable).isBefore(new Date());
    },
  },
  methods: {
    getUserData() {
      const context = this;
      requestService
        .getUserData(context)
        .then((userData) => {
          context.userData = userData;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });

      requestService
        .getRefunds(context)
        .then(
          (refund) => (context.refund = refund != undefined ? refund : null)
        )
        .catch((error) => {
          if (error.status == 404) {
            context.refund = null;
          } else {
            errorManager.manageError(context, error);
          }
        });
    },
  },
  created() {
    this.getUserData();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="css">
.sticky-balance {
  position: fixed;
  width: 100%;
  max-width: 500px;
  margin-top: 6.8rem;
  top: 0;
  z-index: 1;
}
</style>
